import { Component, OnInit, Input, AfterContentChecked } from '@angular/core';
import { SpinnerService } from 'src/app/components/shared-components/spinner/spinner.service';
import { AudienceCapacity } from 'src/app/models/audience-models/audience-capacity.model';

@Component({
  selector: 'app-audience-capacity-offpeak-time-card',
  templateUrl: './audience-capacity-offpeak-time-card.component.html',
  styleUrls: ['./audience-capacity-offpeak-time-card.component.scss']
})
export class AudienceCapacityOffpeakTimeCardComponent implements OnInit, AfterContentChecked {

  @Input() data: AudienceCapacity;
  count: string;
  visitors: number;
  showCounter: boolean;

  constructor(private spinnerService: SpinnerService) {
    this.showCounter = false;
  }

  ngOnInit() {
  }

  ngAfterContentChecked() {
    this.spinnerService.show('offpeak-time-spinner');
    if ((null !== this.data) && (undefined !== this.data)) {
      this.spinnerService.hide('offpeak-time-spinner');
      this.showCounter = true;
      this.count = this.data.OffPeakHour ? this.data.OffPeakHour : '-';
      this.visitors = this.data.OffPeakNumber;
    } else {
      this.count = '-';
      this.visitors = 0;
      this.showCounter = true;
      this.spinnerService.hide('offpeak-time-spinner');
    }
  }

}
